// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Plan {
    static getAttributeTypeMap() {
        return Plan.attributeTypeMap;
    }
}
Plan.discriminator = undefined;
Plan.additionalProperties = false;
Plan.attributeTypeMap = [
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PatientResponse"
    },
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
    {
        "name": "cardHolderId",
        "baseName": "cardHolderId",
        "type": "string"
    },
    {
        "name": "pbmName",
        "baseName": "pbmName",
        "type": "string"
    },
    {
        "name": "pbmPhone",
        "baseName": "pbmPhone",
        "type": "string"
    },
    {
        "name": "familyUnitNumber",
        "baseName": "familyUnitNumber",
        "type": "string"
    },
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "pbmResponseMessage",
        "baseName": "pbmResponseMessage",
        "type": "string"
    },
];
//# sourceMappingURL=plan.js.map